module.exports = __webpack_public_path__ + "media/images/blog/cate-arrow-3397e051a6c7a7b25f3d023447f14f52.svg";